import { render } from "./Dashboard-EIS-Pelbagai.vue?vue&type=template&id=dc8edc70"
import script from "./Dashboard-EIS-Pelbagai.vue?vue&type=script&lang=js"
export * from "./Dashboard-EIS-Pelbagai.vue?vue&type=script&lang=js"

import "./Dashboard-EIS-Pelbagai.vue?vue&type=style&index=0&id=dc8edc70&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__